import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from '../services/api';

// const demoNews = [
//     {
//         id: '1',
//         title: 'National Auto Gymkhana Championship 2026: Registration Open',
//         imageUrl: 'https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?q=80&w=800&auto=format&fit=crop',
//         date: '2026-04-15T10:00:00Z', // date-fns will format this
//         content: 'Registration is now officially open for the upcoming National Championship...'
//     },
//     {
//         id: '2',
//         title: 'New Precision Steering Techniques for Tight Maneuvers',
//         imageUrl: 'https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?q=80&w=800&auto=format&fit=crop',
//         date: '2026-04-10T14:30:00Z',
//         content: 'Mastering the hand-brake turn is just the beginning. Learn the new trends...'
//     },
//     {
//         id: '3',
//         title: 'Upcoming Guwahati Gymkhana Trials: Venue and Schedule',
//         imageUrl: 'https://images.unsplash.com/photo-1603386329225-868f9b1ee6c9?q=80&w=800&auto=format&fit=crop',
//         date: '2026-04-05T09:15:00Z',
//         content: 'The local trials are returning to Guwahati this summer. Check the details...'
//     },
//     {
//         id: '4',
//         title: 'Vehicle Prep: Best Tires for Wet Track Conditions',
//         imageUrl: 'https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=800&auto=format&fit=crop',
//         date: '2026-03-28T16:45:00Z',
//         content: 'Tire choice can make or break your time on a wet gymkhana course...'
//     }
// ];

export const fetchLatestNews = createAsyncThunk('news/fetchLatestNews', async (limit, { rejectWithValue }) => {
    try {
        const response = limit ? await api.get(`/news/latest?limit=${limit}`) : await api.get(`/news/latest`);
        const data = response.data;
        // Ensure we handle potential data structure variations
        const newsItems = Array.isArray(data) ? data : (data.items || []);
        return limit ? newsItems.slice(0, limit) : newsItems;
    } catch (error) {
        return rejectWithValue(error?.message || 'Failed to fetch latest news');
    }
}
);

const newsSlice = createSlice({
    name: 'news',
    initialState: {
        items: [],
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLatestNews.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchLatestNews.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload;
            })
            .addCase(fetchLatestNews.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error.message;
            });
    },
});

export const selectAllNews = (state) => state.news.items;
export const selectNewsStatus = (state) => state.news.status;
export const selectNewsError = (state) => state.news.error;

export default newsSlice.reducer;
